//以旧换新管理相关 api
import request from '@/utils/request'
const baseService = 'autoapp-default-server-recovery'
//网点旧机库存模块 start
/**
 * @function  网点旧机库存模块-获取库存列表
 * @property {object}  params - 请求参数.
 * @property {string}  params.outletsNo - 网点编码
 * @returns {Promise<object>}
 */
export function getOldMachineRepertoryList(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/getOldMachineRepertoryByOutletsNo`,
    method: 'post',
    data
  })
}

/**
 * @function  网点旧机库存模块-获取库存详情
 * @property {object}  params - 请求参数.
 * @property {string}  params.outletsNo - 网点编码
 * @property {string}  params.provinceCode - 省编码
 * @property {string}  params.cityCode - 市编码
 * @returns {Promise<object>}
 */

export function getOldMachineRepertoryDetail(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/getRecoveryApplyByOutletsNo`,
    method: 'post',
    data
  })
}

/**
 * @function  网点旧机库存模块-创建回收单
 * @property {object}  data - 请求参数.
 * @property {string}  data.appointDate - 预约回收日期 yyyy-mm-dd
 * @property {string}  data.carrierNo - 承运商
 * @property {string}  data.recoveryWorker - 回收师傅
 * @property {string}  data.recoveryWorkerName - 回收师傅名称
 * @property {string}  data.networkNo - 网点编码
 * @property {string}  data.detailAddress - 回收地址
 * @property {string}  data.recoveryNum - 回收数量
 * @property {string}  data.estimateVolume - 预估方数
 * @property {string}  data.estimateWeight - 预估重量
 * @property {string}  data.warehouseNo - 旧机柜归集仓库
 * @property {string}  data.warehouseName - 旧机柜归集仓库名称
 * @property {string}  data.wmsWarehouse - 是否 wms 仓库
 * @property {Array}  data.dto - 旧机库存明细
 * @returns {Promise<object>}
 */

export function saveRecoveryApply(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/saveRecoveryApply`,
    method: 'post',
    data
  })
}

/**
 * @function  网点旧机库存模块-获取回收师傅列表
 * @property {object}  params - 请求参数.
 * @property {string}  params.carrierNo - 承运商编码
 * @returns {Promise<object>}
 */

export function getEngineerList(carrierNo) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/findEngineerByOrgId/${carrierNo}`,
    method: 'post'
  })
}

/**
 * @function  旧机回收订单模块-获取回收订单列表
 * @property {object}  params - 请求参数.
 * @property {string}  params.orderNo - 订单编号
 * @property {string}  params.status - 订单状态
 * @property {string}  params.networkNo - 网点编码
 * @property {string}  params.outletsNo - 网点名称 （暂无）
 * @property {string}  params.provinceCode - 省
 * @property {string}  params.cityCode - 市
 * @property {string}  params.countyCode - 区
 * @property {string}  params.contact - 联系人
 * @property {string}  params.tel - 联系人电话
 * @property {string}  params.carrierNo - 承运商编码
 * @property {string}  params.warehouseNo - 归集仓库编码
 * @property {string}  params.createStartDate - 创建时间开始
 * @property {string}  params.createEndDate - 创建时间结束
 * @property {string}  params.appointStartDate - 预约时间开始
 * @property {string}  params.appointEndDate - 预约时间结束
 * @property {string}  params.completeStartDate - 完成时间开始
 * @property {string}  params.completeEndDate - 完成时间结束
 * @property {string}  params.currPage - 当前页
 * @property {string}  params.pageSize - 页长
 *
 * @returns {Promise<object>}
 */
export function findOldMachineRecoveryList(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/findOldMachineRecoveryList`,
    method: 'post',
    data
  })
}
/**
 * @function  旧机回收订单模块-获取回收订单详情
 * @property {object}  orderNo - 回收单 id.
 * @returns {Promise<object>}
 */
export function getRecoveryOrderByOrderNo(orderNo) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/getRecoveryOrderByOrderNo/${orderNo}`,
    method: 'get'
  })
}
/**
 * @function  旧机回收订单模块-车辆信息维护
 * @property {object}  params -入参对象
 * @property {object}  params.operateType -2 车辆信息维护
 * @property {object}  params.driverName -司机姓名
 * @property {object}  params.driverTel - 电话
 * @property {object}  params.vehicleLicenseNo - 车辆牌号
 * @returns {Promise<object>}
 */
export function operateCarInfo(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/operateRecoveryApply`,
    method: 'put',
    data
  })
}

/**
 * @function  旧机回收订单模块-改派
 * @property {object}  data -入参对象
 * @property {object}  data.operateType - 1 改派
 * @property {object}  data.appointDate -预约时间 yyyy-mm-dd
 * @property {object}  data.carrierNo - 承运商
 * @property {object}  data.recoveryWorker - 回收师傅
 * @property {string}  data.recoveryWorkerName - 回收师傅名称
 * @returns {Promise<object>}
 */
export function changeOrder(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/operateRecoveryApply`,
    method: 'put',
    data
  })
}

/**
 * @function  旧机回收订单模块-取消回收单
 * @property {object}  orderNo -入参对象
 * @returns {Promise<object>}
 */
export function cancelOrder(orderNo) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/cancelRecoveryApply/${orderNo}`,
    method: 'post'
  })
}
/**
 * @function  旧机查询模块-查询列表
 * @property {object}  params - 请求参数.
 * @returns {Promise<object>}
 */
export function getOldMachineList(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/oldMachineDetailList`,
    method: 'post',
    data
  })
}
/**
 * @function  旧机查询模块-获取操作记录
 * @property {object}  params - 请求参数.
 * @returns {Promise<object>}
 */
export function getOldMachineDetail(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/oldMachineOperateByWorkOrderNo`,
    method: 'post',
    data
  })
}
/**
 * @function  旧机查询模块-旧机回收详情
 * @property {object}  params - 请求参数.
 * @property {string}  params.sourceWorkOrderNo - 工单来源编号
 * @property {string}  params.id - 工单id
 * @returns {Promise<object>}
 */
export function getOldMachineRecycleDetail(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/getOldMachineRecycleDetail`,
    method: 'post',
    data
  })
}

/**
 * @function 获取承运商列表
 * @returns {Promise<object>}
 */
export function getPartner() {
  return request({
    url: `${baseService}/api/oldMachineRecovery/findPartnerManagement`,
    method: 'get'
  })
}
/**
 * @function 获取归集仓列表
 * @returns {Promise<object>}
 */
export function getWarehouseList() {
  return request({
    url: `${baseService}/api/oldMachineRecovery/findWarehouse`,
    method: 'get'
  })
}

/**
 * @function 获取销司列表
 * @returns {Promise<object>}
 */
export function getRegion() {
  return request({
    url: `${baseService}/api/oldMachineRecovery/queryRegion`,
    method: 'post',
    data: {
      serviceType: ['售后']
    }
  })
}
//旧机查询模块end

//承运商管理模块 start
/**
 * @function  承运商管理列表
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function getPartnerList(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findAllByCondition`,
    method: 'post',
    data
  })
}
/**
 * @function  添加承运商-保存承运商保证金
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function savePartnership(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/savePartnership`,
    method: 'post',
    data
  })
}

/**
 * @function  移除承运商
 * @property {object}  partnershipId - 请求参数.
 * @returns {Promise<object>}
 */
export function removePartnership(partnershipId) {
  return request({
    url: `${baseService}/api/partnerManagementBond/deleteByPartnershipId/${partnershipId}`,
    method: 'delete'
  })
}

/**
 * @function  对应的保证金管理列表查询
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function findBondSerialByPartnershipId(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findBondSerialByPartnershipId`,
    method: 'post',
    data
  })
}

/**
 * @function  保证金缴纳/扣除
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function operatePartnerBond(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/bondOperateByPartnershipId`,
    method: 'post',
    data
  })
}

/**
 * @function  承运商区域分配列表查询
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function getPartnerRegionList(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findPartnerRegionAllocate`,
    method: 'post',
    data
  })
}

/**
 * @function  承运商分配
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function savePartnerAllocateRegion(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/savePartnerAllocateRegion`,
    method: 'post',
    data
  })
}

/**
 * @function  获取省份
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function findAllProvince(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findAllProvince`,
    method: 'post',
    data
  })
}
/**
 * @function  获取城市
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function findAllCity(provinceCode) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findAllCity/${provinceCode}`,
    method: 'post'
  })
}

export function getCityLevelEnum(cityCode) {
  return request({
    url: `${baseService}/api/common/getCityLevelEnum`,
    method: 'get'
  })
}

/**
 * @function 获取(未分配保证金的)承运商列表
 * @returns {Promise<object>}
 */
export function getPartnerByBond() {
  return request({
    url: `${baseService}/api/partnerManagementBond/findPartnerManagement`,
    method: 'post'
  })
}

/**
 * @function 获取(已分配保证金的)承运商列表
 * @returns {Promise<object>}
 */
export function getPartnerManagementBond() {
  return request({
    url: `${baseService}/api/partnerManagementBond/getPartnerManagementBond`,
    method: 'post'
  })
}

/**
 * @function 旧机结算
 * @returns {Promise<object>}
 */
export function settlementOrder(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/settlementOrder`,
    method: 'post',
    data
  })
}
/**
 * @function 渠道类型
 * @returns {Promise<object>}
 */
export function salePlatformMap() {
  return request({
    url: `${baseService}/api/common/getSalePlatformMap`,
    method: 'get'
  })
}

/**
 * @function 旧机状态
 * @returns {Promise<object>}
 */
export function getAppraisalNodeEnumsMap() {
  return request({
    url: `${baseService}/api/common/getAppraisalNodeEnumsMap`,
    method: 'get'
  })
}

/**
 * @function 编辑回收单图片信息
 * @returns {Promise<object>}
 */
export function updateOldMachineRecovery(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/updateOldMachineRecovery`,
    method: 'post',
    data
  })
}

/**
 * @function 旧机查询-结算单-导出
 * @returns {Promise<object>}
 */
export function exportSettlementList(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/exportSettlementList`,
    method: 'post',
    data
  })
}

/**
 * @function 旧机查询-结算单-数据查询
 * @returns {Promise<object>}
 */
export function downSettlementList(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/downSettlementList`,
    method: 'post',
    data
  })
}

/**
 * @function 旧机查询-结算单-明细查询
 * @returns {Promise<object>}
 */
export function settlementExportDetail(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/settlementExportDetail`,
    method: 'post',
    data
  })
}

/**
 * @function 城市等级看板-城市等级看板
 * @returns {Promise<object>}
 */
export function pageCondition(data) {
  return request({
    url: `${baseService}/api/city/pageCondition`,
    method: 'post',
    data
  })
}
//承运商管理模块 end

/**
 * @function 以旧换新数据看板-格力以旧换新-分页查询
 * @returns {Promise<object>}
 */
export function getGreeOldForNew(data) {
  return request({
    url: `${baseService}/api/dataBorad/oldMachineRate/pageCondition`,
    method: 'post',
    data
  })
}

/**
 * @function 以旧换新数据看板-格力以旧换新-数据看板指标计算
 * @returns {Promise<object>}
 */
export function getAvgRate(data) {
  return request({
    url: `${baseService}/api/dataBorad/oldMachineRate/getRate`,
    method: 'post',
    data
  })
}

/**
 * @function 获取导出字段枚举值
 * @returns {Promise<object>}
 */
export function getExportField() {
  return request({
    url: `${baseService}/api/dataBorad/oldMachineRate/getExportField`,
    method: 'get'
  })
}

/**
 * @function 获取维度枚举值
 * @returns {Promise<object>}
 */
export function getOldMachineCompletedDimensionMap() {
  return request({
    url: `${baseService}/api/dataBorad/oldMachineRate/getOldMachineCompletedDimensionMap`,
    method: 'get'
  })
}

/**
 * @function 格力以旧换新看板-导出
 * @returns {Promise<object>}
 */
export function exportOldMachineCompleted(data) {
  return request({
    url: `${baseService}/api/dataBorad/newAndOld/exportPageCondition`,
    method: 'post',
    data
  })
}

//数据看板-履约监控-普通用户订单
/**
 * @function 数据看板-履约监控-普通用户订单-获取指标（统一接口）
 * @returns {Promise<object>}
 */
export function getUserOrderRate(data) {
  return request({
    url: `${baseService}/api/dataBorad/userOrderRate/getUserOrderRate`,
    method: 'post',
    data
  })
}

/**
 * @function 数据看板-履约监控-普通用户订单-预约及时率和超时预约率
 * @deprecated 已废弃，请使用 getUserOrderRate
 * @returns {Promise<object>}
 */
export function onTimeReservationRate(data) {
  return request({
    url: `${baseService}/api/dataBorad/normalOrderDataBoard/onTimeReservationRate`,
    method: 'post',
    data
  })
}

/**
 * @function 数据看板-履约监控-普通用户订单-准时完工率、超时完工率、完工时长、遗留率
 * @deprecated 已废弃，请使用 getUserOrderRate
 * @returns {Promise<object>}
 */
export function completionPunctualityRate(data) {
  return request({
    url: `${baseService}/api/dataBorad/normalOrderDataBoard/completionPunctualityRate`,
    method: 'post',
    data
  })
}

/**
 * @function 数据看板-履约监控-普通用户订单-完工率和取消率
 * @deprecated 已废弃，请使用 getUserOrderRate
 * @returns {Promise<object>}
 */
export function completionAndCancelRate(data) {
  return request({
    url: `${baseService}/api/dataBorad/normalOrderDataBoard/completionAndCancelRate`,
    method: 'post',
    data
  })
}

/**
 * @function 数据看板-履约监控-普通用户订单-列表详情查询（分页）
 * @returns {Promise<object>}
 */
export function pageUserOrderRate(data) {
  return request({
    url: `${baseService}/api/dataBorad/userOrderRate/pageUserOrderRate`,
    method: 'post',
    data
  })
}

/**
 * @function 数据看板-履约监控-普通用户订单-列表详情查询
 * @deprecated 已废弃，请使用 pageUserOrderRate
 * @returns {Promise<object>}
 */
export function getMetricsDetailList(data) {
  return request({
    url: `${baseService}/api/dataBorad/oldMachineRate/pageCondition`,
    method: 'post',
    data
  })
}

/**
 * @function 数据看板-履约监控-普通用户订单-获取导出字段枚举值
 * @returns {Promise<object>}
 */
export function getNomalExportField() {
  return request({
    url: `${baseService}/api/dataBorad/userOrderRate/getExportField`,
    method: 'get'
  })
}

/**
 * @function 数据看板-履约监控-普通用户订单-获取维度枚举值
 * @returns {Promise<object>}
 */
export function getNormalOrderMetricsDimensionMap() {
  return request({
    url: `${baseService}/api/dataBorad/userOrderRate/getNormalOrderMetricsDimensionMap`,
    method: 'get'
  })
}

/**
 * @function 数据看板-履约监控-普通用户订单-获取预约时效枚举值
 * @returns {Promise<object>}
 */
export function getBookingTimelinessEnum() {
  return request({
    url: `${baseService}/api/dataBorad/normalOrderDataBoard/getBookingTimelinessEnum`,
    method: 'get'
  })
}

/**
 * @function 数据看板-履约监控-普通用户订单-获取完工时效枚举值
 * @returns {Promise<object>}
 */
export function getCompletionTimelinessEnum() {
  return request({
    url: `${baseService}/api/dataBorad/normalOrderDataBoard/getCompletionTimelinessEnum`,
    method: 'get'
  })
}

/**
 * @function 数据看板-履约监控-普通用户订单-执行普通订单统计
 * @returns {Promise<object>}
 */
export function doNormalOrderTotal() {
  return request({
    url: `${baseService}/api/dataBorad/normalOrderDataBoard/doNormalOrderTotal`,
    method: 'get'
  })
}

/**
 * @function 旧机回收订单模块-挂起订单
 * @property {object}  orderNo - 订单编号
 * @returns {Promise<object>}
 */
export function hangupOrder(orderNo) {
  return request({
    url: `${baseService}/api/oldMachine/hangup?orderNo=${orderNo}`,
    method: 'post'
  })
}

/**
 * @function 旧机回收订单模块-激活订单
 * @property {object}  orderNo - 订单编号
 * @returns {Promise<object>}
 */
export function activateOrder(orderNo) {
  return request({
    url: `${baseService}/api/oldMachine/activate?orderNo=${orderNo}`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/oldForNew.js